const LogoBlue = ({
  width = 30,
  height = 30,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.68457 27.5416V15.2602C3.68457 12.9444 3.68457 11.7865 4.404 11.0671C5.12342 10.3477 6.28132 10.3477 8.59711 10.3477C10.9129 10.3477 12.0708 10.3477 12.7902 11.0671C13.5097 11.7865 13.5097 12.9444 13.5097 15.2602"
        stroke="#2D96A7"
        strokeWidth="1.8422"
      />
      <path
        d="M20.8785 27.5431V20.1743C20.8785 17.8585 20.8785 16.7006 20.1591 15.9811C19.4397 15.2617 18.2818 15.2617 15.966 15.2617H13.5097C11.1939 15.2617 10.036 15.2617 9.31659 15.9811C8.59717 16.7006 8.59717 17.8585 8.59717 20.1743V27.5431"
        stroke="#2D96A7"
        strokeWidth="1.8422"
      />
      <path
        d="M25.7909 27.5458V10.0719C25.7909 8.42518 25.7909 7.60181 25.3535 6.97064C24.9161 6.33948 24.1452 6.05037 22.6033 5.47216C19.5879 4.3414 18.0802 3.77601 17.023 4.50865C15.9658 5.24128 15.9658 6.85149 15.9658 10.0719V15.2645"
        stroke="#2D96A7"
        strokeWidth="1.8422"
      />
      <path
        d="M4.9126 10.3493V8.50705C4.9126 7.34915 4.9126 6.77021 5.27231 6.41049C5.63202 6.05078 6.21097 6.05078 7.36887 6.05078H9.82514C10.983 6.05078 11.562 6.05078 11.9217 6.41049C12.2814 6.77021 12.2814 7.34915 12.2814 8.50705V10.3493"
        stroke="#2D96A7"
        strokeWidth="1.8422"
        strokeLinecap="round"
      />
      <path
        d="M8.59717 5.43674V2.98047"
        stroke="#2D96A7"
        strokeWidth="1.8422"
        strokeLinecap="round"
      />
      <path
        d="M27.0188 27.543L2.45605 27.543"
        stroke="#2D96A7"
        strokeWidth="1.8422"
        strokeLinecap="round"
      />
      <path
        d="M12.2812 18.9453H17.1938"
        stroke="#2D96A7"
        strokeWidth="1.8422"
        strokeLinecap="round"
      />
      <path
        d="M12.2812 22.6289H17.1938"
        stroke="#2D96A7"
        strokeWidth="1.8422"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LogoBlue;
